function showSmsConfirm() {
    if ($('.modal-reg-employer-inn-block').length) {
      let modal = document.querySelector('._reg-employer');
      let hiddenBlock = modal.querySelector('.tabs-pane._active').querySelector('.modal-reg-employer-inn-block');
      //let telInput = modal.querySelector('._js-input-tel-reg');

      hiddenBlock.classList.add('_open');
      hiddenBlock.querySelector('._js-sms-confirm').value = '';
      sendSms(this);
      //telInput.classList.add('_valid');
    }
}

function sendSms($phoneInput) {
    let time = 30;

    $.ajax({
        url: '/local/ajax/confirmPhone.php',
        method: 'POST',
        data: {
            action: 'sendSms',
            phone: $phoneInput.val()
        }
    });
    let $againSendButton = $phoneInput.closest('form').find('.modal-reg-employer-inn-block__btn');
    let $timerBlock = $phoneInput.closest('form').find('.modal-reg-employer-inn-block__count');

    $againSendButton.prop('disabled', true);
    setTimeout(function () {
        $againSendButton.prop('disabled', false);
    }, time * 1000);


    let timer = setInterval(function () {
        time--;
        if (time >= 0) {
            $timerBlock.html(time);
        } else {
            clearInterval(timer);
        }
    }, 1000);
}

function inputSmsCofirm(id) {
  if (id.length) {
      id.mask('9999', {completed: checkSmsConfirm});
  }
}

function checkSmsConfirm() {
    let $form = this.closest('form');
    $.ajax({
        url: '/local/ajax/confirmPhone.php',
        method: 'POST',
        dataType: 'json',
        data: {
            action: 'checkCode',
            code: this.val(),
            phone: $form.find('._js-input-tel-reg').val()
        }
    }).done(response => {
        if (response.success) {
            $form.find('.confirm-phone-flag').val('Y');
            $form.find('._js-input-tel-reg').addClass('_valid').prop('readonly', true);
            $form.find('.modal-reg-employer-inn-block').removeClass('_open');
            $form.find('._js-input-tel-reg')[0].dispatchEvent(new Event('keyup'));
        } else {
            $form.find('._js-sms-confirm').closest('.input').addClass('_error');
        }
    });
}

function sendSmsButton() {
    $(document).on('click', '.modal-reg-employer-inn-block__btn', function (e) {
        e.preventDefault();
        sendSms($(this).closest('form').find('._js-input-tel-reg'));
    })
}
